/* Hushpaw theme script: Buy now flow, add-on toggle, delivery dates, sticky bar, gallery counter. */
(function () {
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function showError(form, message) {
    var el = form.querySelector('[data-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function buyNow(form, button) {
    var items = $$('input[name$="[id]"]', form)
      .filter(function (i) { return i.type !== 'checkbox' || i.checked; })
      .map(function (i) { return { id: Number(i.value), quantity: 1 }; });
    if (!items.length) return;

    var original = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.textContent = button.getAttribute('data-loading') || 'Going to checkout…';
    }
    var err = form.querySelector('[data-error]');
    if (err) err.hidden = true;

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (res.ok) {
          window.location.href = '/checkout';
          return;
        }
        return res.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'This item could not be added');
        });
      })
      .catch(function (e) {
        if (button) {
          button.disabled = false;
          button.innerHTML = original;
        }
        showError(form, e.message + '. Try again, or contact us if it keeps happening.');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-buy-now]')) return;
    if (!window.fetch) return; // falls back to a normal form post with return_to=/checkout
    event.preventDefault();
    var button = event.submitter || form.querySelector('[type="submit"]');
    buyNow(form, button);
  });

  // Add-on checkbox updates every price label tied to it
  $$('[data-bump]').forEach(function (box) {
    var label = box.closest('.bump');
    function sync() {
      $$('[data-total]').forEach(function (el) {
        el.textContent = box.checked ? el.getAttribute('data-with') : el.getAttribute('data-base');
      });
      if (label) label.classList.toggle('is-on', box.checked);
    }
    box.addEventListener('change', sync);
    sync();
  });

  // Delivery window in real dates, counting business days
  $$('[data-eta]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (!min || !max) return;
    function addBusinessDays(n) {
      var d = new Date();
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    }
    var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
    el.textContent = fmt(addBusinessDays(min)) + ' – ' + fmt(addBusinessDays(max));
  });

  // Sticky buy bar shows whenever the main button is off screen
  var main = document.querySelector('[data-main-buy]');
  var bar = document.querySelector('[data-sticky]');
  if (main && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(main);
  }

  // Gallery position counter on phones
  $$('[data-gallery]').forEach(function (g) {
    var counter = g.parentElement.querySelector('[data-count]');
    if (!counter) return;
    var total = g.children.length;
    g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / Math.max(g.clientWidth, 1)) + 1;
      counter.textContent = Math.min(i, total) + ' / ' + total;
    }, { passive: true });
  });

  // Close the mobile menu after tapping a link
  $$('.menu__panel a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details');
      if (d) d.removeAttribute('open');
    });
  });

  // Close the mobile menu when tapping anywhere outside it
  document.addEventListener('click', function (e) {
    $$('details.menu[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // Links ending in #buy land on the buy box
  if (location.hash === '#buy') {
    var target = document.getElementById('buy');
    if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 60);
  }
})();
